import BearerTableRow from './BearerTableRow';

const BearerCallbacksTable = ({
  tableRows,
  targetOptions,
  rowDirty,
  rowSaved,
  savingIndex,
  onUpdateTargets,
  onSaveRow
}) => {
  return (
    <div className='overflow-x-auto border border-gray-200 rounded-md'>
      <table className='min-w-full text-sm'>
        <thead className='bg-gray-50'>
          <tr>
            <th className='text-left p-3 font-semibold'>User email</th>
            <th className='text-left p-3 font-semibold'>Integrations</th>
            <th className='text-left p-3 font-semibold'>Actions</th>
          </tr>
        </thead>
        <tbody>
          {tableRows.length === 0 && (
            <tr>
              <td colSpan={3} className='p-4 text-gray-500'>
                No users found
              </td>
            </tr>
          )}
          {tableRows.map((row, index) => (
            <BearerTableRow
              row={row}
              index={index}
              onSave={onSaveRow}
              isDirty={rowDirty[index]}
              isSaved={rowSaved[index]}
              targetOptions={targetOptions}
              key={`${row.user_id}-${index}`}
              isSaving={savingIndex === index}
              onUpdateTargets={onUpdateTargets}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BearerCallbacksTable;
